import { useRef, memo, useLayoutEffect } from "react"
import { useGLTF } from "@react-three/drei"

import { ApartmentMaterial, ArchiMaterial } from "../../../ApartmentFinderConfig/MaterialHelpers"

import { Html, useTexture } from "@react-three/drei"
import {
  // isIOS,
  returnsAptID,
  returnsBlockIDFromName,
  returnsFloor,
  returnsPlotNumber
} from "../Utils/Helpers"
import { useAvailableApartments, useBlockIDbyPlotNumber } from "../Utils/hooks"
import {
  MeshStandardMaterial,
  sRGBEncoding,
  DoubleSide,
  Object3D,
  MeshBasicMaterial,
  MixOperation,
  Matrix4
} from "three"
import { treesObject } from "../../../ApartmentFinderConfig/instanceData"
import { masterTexturePath } from "../../../ApartmentFinderConfig/general"
import { useStore } from "../../../state/store"
import { useTransition } from "@react-spring/core"
import { animated as aDom } from "@react-spring/web"
import { useMemo } from "react"
const encoding = sRGBEncoding
let isIOS = false

// ** Interactive Mesh Element * //

export const InteractiveMeshElement = ({
  center,
  name,
  mesh,
  bedIndex,
  statusIndex,
  availableIndex
}) => {
  const diffuseTexturePath = `${masterTexturePath}${name.split("-")[1]}_d${
    isIOS ? ".compressed" : ""
  }.jpg`

  const diffuseMap = useTexture(diffuseTexturePath)
  diffuseMap.flipY = false

  // console.log(name, bedIndex[returnsPlotNumber(name)])
  diffuseMap.encoding = encoding

  const storredObjects = {
    ID: useAvailableApartments().map(obj => Number(obj.PlotNumber))
  }

  return (
    <>
      <ApartmentLabel center={center} name={name} />
      <DynamicMeshDisplay
        storredObjects={storredObjects}
        name={name}
        mesh={mesh}
        diffuseMap={diffuseMap}
        beds={bedIndex[returnsPlotNumber(name)]}
        status={statusIndex[returnsPlotNumber(name)]}
        available={availableIndex.includes(returnsPlotNumber(name))}
      />
    </>
  )
}
function DynamicMeshDisplay({ name, mesh, diffuseMap, storredObjects, beds, status, available }) {
  const faveRef = useRef()

  const favourites = useStore(state => state.favourites)

  const activeFloor = useStore(
    state => state.activeFloor,
    (oldState, newState) => compare(oldState, newState, returnsFloor(name))
  )

  //TODO - optimise by comparing state change
  // console.log("MESH")
  function compare(oldT, newT, flr) {
    // console.log(oldT, newT, flr)
    // return !(flr >= newT)
    return false
  }

  const activeBlock = useStore(state => state.activeBlock)

  const floorArr = []

  const isApartment = useMemo(() => !name.includes("AA"), [name])

  for (let i = 0; i <= activeFloor; i++) {
    floorArr.push(i)
  }

  // console.log(activeFloor, floorArr, returnsFloor(name), activeBlock)

  const active =
    activeFloor === null ||
    floorArr.includes(parseInt(returnsFloor(name))) ||
    name.split("-")[3].split("_")[0].replace(/[0-9]/g, "") !== activeBlock?.replace(/[0-9]/g, "")
      ? mesh
      : null

  return (
    <mesh
    onClick={(e)=> 
    
     console.log(e)
    }
      visible={active ? true : false}
      ref={favourites.includes(returnsAptID(name)) ? faveRef : null}
      geometry={mesh}
    >
      {isApartment ? (
        <ApartmentMaterial
          beds={beds}
          status={status}
          active={active}
          name={name}
          map={diffuseMap}
          available={available}
        />
      ) : (
        <ArchiMaterial name={name} map={diffuseMap} />
      )}
    </mesh>
  )
}

function ApartmentLabel({ center, name }) {
  const storredObjects = {
    ID: useAvailableApartments().map(obj => Number(obj.PlotNumber))
  }
  const favourites = useStore(state => state.favourites)

  let floor = returnsFloor(name)

  const favouritesActive = useStore(state => state.favouritesActive)
  const plotnumbers = useBlockIDbyPlotNumber()

  const setActiveApt = useStore(state => state.setActiveApt)
  const activeBlock = useStore(state => state.activeBlock)
  const activeFloor = useStore(state => state.activeFloor)
  let thisAptAvailable = storredObjects.ID.includes(Number(returnsAptID(name))) ? true : false

  // if(name.includes("J")){console.log(name, storredObjects ,floor,activeFloor , "thisAptAvailable",thisAptAvailable, "pt", Number(returnsAptID(name)))}

  const active =
    !favouritesActive && activeBlock && thisAptAvailable && Number(floor) === activeFloor
      ? plotnumbers[Number(returnsAptID(name))]
      : null

  const transition = useTransition(active, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  })

  const clickedMesh = (e, blockID, meshID, floorID) => {
    console.log(blockID, meshID, floorID)
    if (
      thisAptAvailable &&
      activeFloor !== null &&
      blockID.replace(/[0-9]/g, "").includes(activeBlock.replace(/[0-9]/g, ""))
    ) {
      meshID !== "AA" && setActiveApt(Number(meshID))
    }
  }

  const clickedFavouriteMesh = (e, meshID) => {
    favourites.includes(meshID) && setActiveApt(meshID)
  }

  // console.log(item)

  return transition(({ opacity }, item) => (
    <Html zIndexRange={[0, 1]} center position={[center.x, center.y + 100, center.z]}>
      <aDom.h1
        onClick={
       
          favouritesActive
            ? e => {
              clickedFavouriteMesh(e, returnsAptID(name))
            }
            : e => {
             
                // Number(returnsFloor(name)) === activeFloor &&
                //   apartmentStatusByPlotNumber[returnsPlotNumber(name)] === "0" &&
                clickedMesh(e, returnsBlockIDFromName(name), returnsAptID(name), returnsFloor(name))
              }
        }
        style={{
          opacity: opacity,
          cursor: "pointer",
          zIndex: 1,
          fontFamily: "NewParisKingSize-Regular",
          color: "#0A253B",
          fontSize: "1rem"
        }}
      >
        {item}
      </aDom.h1>
    </Html>
  ))
}

// ** Semi-Static Mesh Element * //

export const SemiStaticMeshElement = memo(({ mesh, texturePath, objectID, materialType }) => {
  const favouritesActive = useStore(state => state.favouritesActive)

  const diffuseMap = useTexture(texturePath)
  diffuseMap.flipY = false
  diffuseMap.encoding = encoding

  const FLAT_MAP = new MeshStandardMaterial({
    color: "#fff",
    flatShading: true,

    depthTest: true,
    side: DoubleSide
  })
  const BAKED_MAT = new MeshBasicMaterial({
    map: diffuseMap,
    depthTest: true,
    polygonOffsetUnits: 0.1,
    side: DoubleSide,
    polygonOffset: true
  })

  return (
    <mesh material={favouritesActive && objectID === "gf" ? FLAT_MAP : BAKED_MAT} geometry={mesh} />
  )
})
// ** Static Mesh Element * //
export const StaticMeshElement = memo(({ mesh, texturePath, objectID, materialType }) => {
  const diffuseMap = useTexture(texturePath)
  diffuseMap.flipY = false
  diffuseMap.encoding = encoding

  const BAKED_MAT = new MeshBasicMaterial({
    combine: MixOperation,
    map: diffuseMap,
    depthTest: true,
    polygonOffsetUnits: 11,
    side: DoubleSide,
    polygonOffset: true,

    polygonOffsetFactor: objectID === "gp" ? 2 : objectID.includes("underlap") ? 1 : 0
  })

  return <mesh material={BAKED_MAT} geometry={mesh} />
})

export const Glass = memo(() => {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/assets/apartmentfinder/glass.gltf`)

  const diffuseMap = useTexture(
    isIOS
      ? `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/ref_glass_1.compressed.jpg`
      : `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/ref_glass_1.jpg`
  )

  diffuseMap.encoding = sRGBEncoding
  diffuseMap.flipY = false

  const BAKED_MAT = new MeshBasicMaterial({
    map: diffuseMap,
    opacity: 0.8
  })

  return <mesh material={BAKED_MAT} geometry={nodes.glass7.geometry} />
})

// ** Instanced Mesh Element * //

export const InstanceMesh = memo(({ treeType, nodes, TREE_MAT }) => {
  const meshRef = useRef()

  useLayoutEffect(() => {
    const tempObject = new Object3D()
    let test = new Matrix4()
    treesObject[treeType].map((o, id) => {
      tempObject.position.x = o.x
      tempObject.position.y = o.z
      tempObject.position.z = -o.y
      tempObject.updateMatrix()

      test.elements = tempObject.matrix.elements
      meshRef.current.setMatrixAt(id, test)
      return null
    })
  }, [])

  return (
    <instancedMesh
      // geometry={new SphereGeometry(1000, 5, 5)}
      geometry={nodes[treeType].geometry}
      material={TREE_MAT}
      ref={meshRef}
      args={[null, null, 1000]}
    ></instancedMesh>
  )
})
